import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import PastParticipantsLayer from "../components/PastParticipantsLayer";

const PastParticipantsPage = () => {
    return (
        <MasterLayout>
            <PastParticipantsLayer />
        </MasterLayout>
    );
};

export default PastParticipantsPage;
